<template>
  <v-app>
    <Hamburger
      v-show="isMobile && showHamburger"
      :state="stateNav"
      @sideNavState="navDrawer"
    />

    <template v-if="showSideBar">
      <div @mouseover="isExpanded(true)" @mouseleave="isExpanded(false)">
        <v-navigation-drawer
          v-if="!fullscreen || showSideBar"
          v-model="stateNav"
          floating
          class="shadow"
          app
          width="200px"
          :mobileBreakpoint="1100"
          :expand-on-hover="!isMobile"
          disable-resize-watcher
        >
          <SideBar :expanded="expanded" :isMobile="isMobile" />
        </v-navigation-drawer>
      </div>
    </template>

    <transition name="expand">
      <v-app-bar
        class="header"
        v-show="showHeader"
        height="50"
        app
        :color="colorBasedOnRoute"
        @mouseover="hoverHeader(true)"
        @mouseleave="hoverHeader(false)"
      >
        <Header :fullscreenState="fullscreen" :isMobile="isMobile" />
      </v-app-bar>
    </transition>

    <v-main :class="{ noPad: !showHeader }">
      <router-view
        :key="$route.fullPath"
        :fullscreen="!showHeader"
      ></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Hamburger from "./SideBar/Hamburger.vue";
import SideBar from "./SideBar/SideBar";
import Header from "./Header/Header.vue";
import { eventBus } from "@/main.ts";

export default {
  components: {
    Hamburger,
    SideBar,
    Header,
  },
  data: () => ({
    fullscreen: false,
    stateNav: false,
    showSideBar: false,
    showHeader: false,
    showHamburger: false,
    mouseOnHeader: false,
    isMobile: false,
    expanded: false,
    expandTimeout: undefined,
    mobileTimeout: undefined,
  }),
  watch: {
    isMobile() {
      clearTimeout(this.mobileTimeout);
      if (!this.isMobile) {
        this.mobileTimeout = setTimeout(() => {
          this.stateNav = !this.isMobile;
        }, 500);
      } else {
        this.stateNav = !this.isMobile;
      }
    },
    $route: {
      handler() {
        this.checkRoute(this.$route.path);
      },
      deep: true,
    },
  },
  mounted() {
    eventBus.$on("fullscreen", this.setFullscreen);

    this.isMobile = window.innerWidth < 1100;
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 1100;
    });
    document.addEventListener("mousemove", this.trackPosition);
    setTimeout(() => {
      if (localStorage.getItem("autoLoginInfo")) {
        this.setFullscreen(Boolean(localStorage.getItem("fullscreen")));
        localStorage.removeItem("fullscreen");
        localStorage.removeItem("autoLoginInfo");
      }
    }, 6000);
  },
  computed: {
    colorBasedOnRoute() {
      return this.$vuetify.theme.themes.light.secondary;
    },
  },
  methods: {
    checkRoute(route) {
      let val = true;
      if (route)
        if (route.includes("login") || route.includes("create")) {
          val = false;
        }
      this.showHeader = val;
      this.stateNav = val && !this.isMobile;
      this.showSideBar = val;
      this.showHamburger = val;
    },
    navDrawer(response) {
      this.stateNav = response;
    },
    setFullscreen(val) {
      this.fullscreen = val;
      this.stateNav = !val;
      this.showHamburger = !val;
    },
    trackPosition(e) {
      if (this.fullscreen && !this.mouseOnHeader) {
        this.showHeader = e.clientY < 5;
      }
    },
    hoverHeader(val) {
      this.mouseOnHeader = val;
    },
    isExpanded(value) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.expanded = value;
      }, 100);
    },
  },
};
</script>

<style lang="css" scoped>
.shadow {
  /* -webkit-box-shadow: -8px 77px 30px -6px rgba(212, 212, 212, 0.322);
  -moz-box-shadow: 13px 77px 30px -6px rgba(232, 234, 235, 0.322);
  box-shadow: -8px 78px 30px -2px rgba(214, 214, 214, 0.322); */
  background: #ffffff;
  box-shadow: 0px 0px 40px rgba(94, 107, 128, 0.14);
  transition-duration: 350ms;
}
.v-navigation-drawer__content {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.v-main {
  background-color: #f1f3f6;
  padding-top: 50px !important;
}
/* .v-toolbar {
  position: relative;
} */
.noPad {
  padding-top: 0 !important;
}
.expand-enter-active {
  animation: loading 0.7s;
}
.expand-leave-active {
  animation: loading 0.7s reverse;
}
@keyframes loading {
  from {
    top: -100px;
  }
  to {
    top: 0;
  }
}

@keyframes movement {
  from {
    left: -200px;
  }
  to {
    left: 0;
  }
}
</style>
